var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDelete = function SvgDelete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.92,8.36 L12.92,13.68 L10.64,13.68 L10.64,8.36 L7.6,8.36 L7.6,13.68 L5.32,13.68 L5.32,8.36 L2.28,8.36 L2.28,15.2 C2.28,15.6197364 2.62026359,15.96 3.04,15.96 L15.2,15.96 C15.6197364,15.96 15.96,15.6197364 15.96,15.2 L15.96,8.36 L12.92,8.36 L12.92,8.36 Z M3.37507799e-16,6.08 L18.24,6.08 L18.24,15.2 C18.24,16.8789456 16.8789456,18.24 15.2,18.24 L3.04,18.24 C1.36105436,18.24 9.51213183e-16,16.8789456 0,15.2 L3.37507799e-16,6.08 Z M6.08,2.28 L6.08,0 L12.16,0 L12.16,2.28 L18.24,2.28 L18.24,4.56 L0,4.56 L0,2.28 L6.08,2.28 Z",
    id: "delete-path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-2.7%",
    y: "-2.7%",
    width: "111.0%",
    height: "111.0%",
    filterUnits: "objectBoundingBox",
    id: "delete-filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    in: "SourceAlpha",
    result: "deleteShadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 1 0",
    type: "matrix",
    in: "deleteShadowOffsetOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-656.000000, -641.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.000000, 171.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(657.000000, 470.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#delete-filter-2)",
    xlinkHref: "#delete-path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#delete-path-1"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete.faf1ea3b.svg";
export { ForwardRef as ReactComponent };